<ngb-alert class="alert-fixed" *ngIf="isVisible()" [type]="type" (close)="open = false">
  <i class="fa fa-exclamation-triangle" *ngIf="type === 'danger'"></i>
  <i class="fa fa-check" *ngIf="type === 'success'"></i>
  <i class="fa fa-info" *ngIf="type === 'info'"></i>
  {{ message }}
</ngb-alert>


// WEBPACK FOOTER //
// ./src/app/shared/alert/alert.component.html